module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runmetrix_content"
  }, [_c('div', {
    staticStyle: {
      "padding-left": "2rem",
      "padding-top": "1px"
    }
  }, [_vm._v("Runmetrix")]), _vm._v(" "), _c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "12px"
    },
    attrs: {
      "is-loading": _vm.loading,
      "is-horizontal-resize": "",
      "columns": _vm.tableConfig.columns,
      "table-data": _vm.tableConfig.tableData,
      "title-row-height": 40,
      "row-height": 40,
      "border": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20 bold",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "pageIndex": _vm.pageIndex + 1,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562c1e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RunMetrix.vue
// module id = 1669
// module chunks = 2